export default __webpack_public_path__ + "static/grid-breakpoints-dark-ba18d0629fb4eaae10deb961c0bd15ee.png";